export const RECORDS_LIMIT = 10;
export const PER_PAGE = 100;

export const LOADING_PLACEHOLDER = "Please Wait...";

export const FILTER_TYPE = {
    INPUT: "input",
    DATE: "date",
    RADIO: "radio",
    SELECT: "select",
};

export const PRODUCT_GROUPS = {
    JERSEYS: 1,
    TEAM_MERCHANDISE: 2,
    MATCH_BALLS: 3,
};

export const PRODUCT_GROUP_LABELS = {
    [PRODUCT_GROUPS.JERSEYS]: "BP-PG1: J&U",
    [PRODUCT_GROUPS.TEAM_MERCHANDISE]: "BP-PG2: TM",
    [PRODUCT_GROUPS.MATCH_BALLS]: "BP-PG3: MB",
};
